<div class="container-fluid">
  <div class="float-right">
    <img
      src="assets/images/icons/default_icons/icon-close.png"
      alt="icon-close"
      (click)="OnClose()"
      [ngStyle]="{ cursor: 'pointer' }"
    />
  </div>

  <div id="main-form-content">
    <form
      [formGroup]="documentGrp"
      (ngSubmit)="OnSubmit(documentGrp.value)"
      #uploadDocumentsForm="ngForm"
      ngNativeValidate
    >
      <div class="box box-solid box-primary">
        <div class="box-body" formArrayName="fileItems">
          <h2 class="page-header text-blue textCenter padding20Px">Upload Documents</h2>
          <div class="row">
            <div class="col-sm-12">
              <table id="tbl-upload" aria-describedby="table_upload_files">
                <tr class="active">
                  <th id="table_category_attachment">Attachment Category</th>
                  <th style="padding-left: 65px" id="table_file_attachment">File</th>
                  <th id="table_close_attachment"></th>
                </tr>
                <ng-container *ngFor="let item of docItems.controls; let i = index">
                  <tr [formGroupName]="i">
                    <td class="paddingRight40Px">
                      <mat-form-field style="width: auto">
                        <mat-select
                          formControlName="doc_category"
                          panelClass="autoWidthPanel"
                          placeholder="Please select"
                          [(ngModel)]="rcvdFilesId[i]"
                        >
                          <mat-option
                            class="pad5"
                            *ngFor="let attach of attachmnetTypeData; let j = index"
                            [value]="attach"
                          >
                            {{ attach.attachmentType }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td style="padding-left: 65px">
                      <input
                        id="docFile"
                        class="filefield"
                        #mFile
                        formControlName="documentFile"
                        type="file"
                        title="Browse Document"
                        (change)="docFileSlctdEvnt($event, i)"
                        accept="acceptedFileTypes"
                        style="display: none"
                      />
                      <span
                        id="browse"
                        class="clearFix Me-PrimaryDark h4Header"
                        style="cursor: pointer"
                        (click)="mFile.click()"
                      >
                        Browse file
                      </span>
                      <span style="padding: 0 10px">
                        {{ totalDocFileName[i] }}
                      </span>
                      <mat-error class="file_error">
                        {{ getExtensionErrorMessage(i) }}
                      </mat-error>
                    </td>
                    <td class="remove">
                      <img
                        src="assets/images/icons/default_icons/icon-close.png"
                        style="cursor: pointer"
                        alt="iconClose"
                        (click)="removeDocItem(i)"
                      />
                    </td>
                  </tr>
                </ng-container>
              </table>
            </div>
          </div>
        </div>
        <div class="box-footer" style="align-content: center">
          <button type="button" mat-flat-button class="primary-btn" (click)="addDocItem()">Add More</button>
          <button
            type="submit"
            [disabled]="documentGrp.invalid"
            name="submitProfile"
            mat-flat-button
            class="primary-btn margin10Px"
            mat-dialog-close
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
